<template>
  <div class="repay-month-box">
    <div v-if="month == 1" style="display: flex; justify-content: space-around">
      <span class="repay-month-text">1 month &pound;</span>
      <span class="repay-month-text">{{ repayment.monthlyPaymentAmount }}/month*</span>
    </div>
    <div v-else style="display: flex; justify-content: space-around">
      <span class="repay-month-text" >{{month}} months</span>
      <span class="repay-month-text" > &pound;{{ repayment.monthlyPaymentAmount }}/month*</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "repayMonthBox",
  props: {
    month: String,
    repayment: Object,
  },
}
</script>

<style scoped>

</style>